/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';
import { Link, NavLink } from 'react-router-dom';

import DropdownClassic from '../../DropdownClassic';
import Tooltip from '../../Tooltip';

export default function Select({
  label,
  name,
  options,
  value,
  setFieldValue,
  onBlur,
  error,
  touched,
  link,
  tabindex,
  isVisible,
  readOnly,
  defaultValue,
  placeholder,
  fixedPosition,
  style,
  className = '',
  tooltipSize,
  tooltipPosition,
  tooltip,
  reference,
  fullWidth,
}) {
  const ref = useRef();
  const inputRef = reference || ref;

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1) {
      inputRef.current.focus();
    }
  }, [tabindex, isVisible, inputRef]);

  // Set default value
  useEffect(() => {
    if (defaultValue && !value) {
      setFieldValue(name, defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, name, value]);

  const currentOption = options?.find((option) => option.value === value);

  return (
    <div
      className={classNames(className, {
        'pointer-events-none': readOnly && !link,
      })}
      style={style}
    >
      <div className="flex items-center gap-2 mb-1">
        <label className="block text-sm font-medium" htmlFor={name}>
          {label}
        </label>
        {tooltip && (
          <Tooltip size={tooltipSize} position={tooltipPosition}>
            {tooltip}
          </Tooltip>
        )}
      </div>

      {readOnly && link ? (
        <div className="form-input border-0 shadow-none">
          <Link className=" text-indigo-500 underline" to={link()}>
            {value === '' ? '' : currentOption?.label}
          </Link>
        </div>
      ) : (
        <DropdownClassic
          inputRef={inputRef}
          options={options}
          value={value}
          setFieldValue={setFieldValue}
          onBlur={onBlur}
          name={name}
          tabIndex={tabindex}
          readOnly={readOnly}
          placeholder={placeholder}
          fixedPosition={fixedPosition}
          link={link}
          fullWidth={fullWidth}
        />
      )}

      {link && (
        <NavLink
          className="inline-block w-full text-sm underline hover:no-underline text-right"
          to={link.url}
        >
          {link.title}
        </NavLink>
      )}
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
